<ph-dialog [open]="open" size="md" heading="Verify your Stripe account" dismissible="false" (ph-close)="close()">
    <ph-skeleton *ngIf="loading" shape="form" rows="4" stagger label="Loading verification form…"></ph-skeleton>
    <div #stripeContainer [hidden]="loading"></div>
</ph-dialog>
